document.addEventListener("DOMContentLoaded", () => {
    if (window.location.pathname.includes("/wholesale")) {
       let a = document.querySelectorAll('a.button')
    if (a.length) {
        a.forEach(element => {
            if (element.getAttribute('href').includes('drop-us-some-details-about-your-business-for-access-to-our-wholesale-site')) {
                   console.log(element.getAttribute('href'))
            }
        });
    }
    }
});
document.addEventListener("submit", function (e) {
    const btnWrapper = e.target.querySelector(".bss-b2b-rf-submit-button");
    if (!btnWrapper) return;

    e.preventDefault(); 

    setTimeout(() => {
        e.target.submit(); 
    }, 3000);
});